'use strict';

(function(global) {

  /**
   * Настройки предпросмотра для текстовых документов.
   *
   * @since 5.7.0
   */
  class TextDocumentPreviewSettings extends global.BaseDocumentPreviewSettings {

    constructor() {
      super();
      this._enableTrackChangesStorageName = `text-preview-${this.storageGroupName}-enableTrackChanges`;
      this._previewScaleStorageName = `text-preview-${this.storageGroupName}-previewScale`;
      this._showCommentsStorageName = `text-preview-${this.storageGroupName}-showComments`;
    }

    /**
     * @see BaseDocumentPreviewSettings.defaultScale
     */
    static get defaultScale() {
      return '100';
    }

    /**
     * @see BaseDocumentPreviewSettings#commentsVisibility
     */
    get commentsVisibility() {
      return localStorage.getItem(this._showCommentsStorageName) === 'true';
    }
    set commentsVisibility(isVisible) {
      localStorage.setItem(this._showCommentsStorageName, isVisible.toString());
    }

    /**
     * @see BaseDocumentPreviewSettings#trackChangesVisibility
     */
    get trackChangesVisibility() {
      return localStorage.getItem(this._enableTrackChangesStorageName) === 'true';
    }
    set trackChangesVisibility(isVisible) {
      localStorage.setItem(this._enableTrackChangesStorageName, isVisible.toString());
    }

  }

  global.TextDocumentPreviewSettings = TextDocumentPreviewSettings;

})(window.Core.preview);